var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65235 14.625C5.80232 14.625 4.19037 14.0212 2.81652 12.8137C1.44213 11.6066 0.654395 10.0993 0.453304 8.29167H2.10225C2.28993 9.66389 2.90983 10.7986 3.96193 11.6958C5.01458 12.5931 6.24472 13.0417 7.65235 13.0417C9.22086 13.0417 10.5513 12.5039 11.6436 11.4283C12.7365 10.3532 13.2829 9.04375 13.2829 7.5C13.2829 5.95625 12.7365 4.64657 11.6436 3.57096C10.5513 2.49588 9.22086 1.95833 7.65235 1.95833C6.72733 1.95833 5.86264 2.16944 5.05828 2.59167C4.25392 3.01389 3.57691 3.59444 3.02727 4.33333H5.23926V5.91667H0.413086V1.16667H2.02181V3.02708C2.70552 2.18264 3.54018 1.52951 4.52579 1.06771C5.51087 0.605903 6.55306 0.375 7.65235 0.375C8.65781 0.375 9.59971 0.562889 10.4781 0.938667C11.3559 1.31497 12.1201 1.82296 12.7705 2.46263C13.4204 3.10282 13.9366 3.8549 14.3189 4.71888C14.7007 5.58338 14.8916 6.51042 14.8916 7.5C14.8916 8.48958 14.7007 9.41636 14.3189 10.2803C13.9366 11.1448 13.4204 11.8969 12.7705 12.5366C12.1201 13.1768 11.3559 13.685 10.4781 14.0613C9.59971 14.4371 8.65781 14.625 7.65235 14.625ZM9.90457 10.825L6.84799 7.81667V3.54167H8.45671V7.18333L11.0307 9.71667L9.90457 10.825Z",
    fill: "#154365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.c30d8136e9e3b61f910d72bd1f0a01e4.svg";
export { ForwardRef as ReactComponent };